// Internationalization (PT-BR + EN)
import React, { createContext, useContext, useEffect, useState } from "react";

const TRANSLATIONS = {
  en: {
    common: {
      shop_now: "Shop Now",
      explore_deals: "Explore Deals",
      see_all: "See all",
      add_to_cart: "Add to cart",
      buy_now: "Buy now",
      out_of_stock: "Out of stock",
      in_stock: "In stock",
      search_placeholder: "Search games, gift cards…",
      cart: "Cart",
      wishlist: "Wishlist",
      account: "Account",
      login: "Login",
      register: "Register",
      logout: "Logout",
      dashboard: "Dashboard",
      orders: "Orders",
      settings: "Settings",
      admin: "Admin",
      currency_symbol: "$",
      total: "Total",
      subtotal: "Subtotal",
      discount: "Discount",
      service_fee: "Service fee",
      checkout: "Checkout",
      continue_shopping: "Continue shopping",
      apply: "Apply",
      promo_code: "Promo code",
      qty: "Qty",
      remove: "Remove",
      empty_cart: "Your cart is empty",
      empty_wishlist: "Your wishlist is empty",
      explore_now: "Explore now",
      free: "Free",
      added: "Added to cart",
      removed: "Removed",
      please_login: "Please log in",
      welcome_back: "Welcome back",
      create_account: "Create your account",
      no_account: "No account?",
      have_account: "Have an account?",
      email: "Email",
      password: "Password",
      name: "Name",
      sign_in: "Sign in",
      sign_up: "Sign up",
    },
    nav: {
      games: "Games",
      gift_cards: "Gift Cards",
      subscriptions: "Subscriptions",
      deals: "Deals",
      new_releases: "New Releases",
      support: "Support",
      home: "Home",
    },
    hero: {
      title_a: "LEVEL UP",
      title_b: "YOUR DIGITAL",
      title_c: "WORLD",
      subtitle: "Premium game keys, gift cards and instant digital delivery.",
      badge: "Premium Gaming Marketplace",
    },
    home: {
      featured_games: "Featured Games",
      trending: "Trending Now",
      flash_deals: "Flash Deals",
      new_releases: "New Releases",
      gift_cards: "Gift Cards",
      subscriptions: "Gaming Subscriptions",
      top_sellers: "Top Sellers",
      recently_added: "Recently Added",
      popular_categories: "Popular Categories",
      reviews: "What gamers say",
      newsletter_title: "Don't miss a single deal",
      newsletter_sub: "Subscribe and get exclusive offers and early access drops.",
      newsletter_cta: "Subscribe",
      strip: {
        instant: { t: "Instant Delivery", s: "Receive within minutes" },
        secure: { t: "Secure Payment", s: "100% safe environment" },
        prices: { t: "Best Prices", s: "Unbeatable offers" },
        support: { t: "24/7 Support", s: "Dedicated team" },
      },
    },
    product: {
      similar: "Similar products",
      description: "Description",
      requirements: "Requirements",
      reviews: "Reviews",
      delivery: "Instant delivery",
      delivery_sub: "Receive your code within minutes after payment confirmation.",
      secure: "Secure payment",
      secure_sub: "Your transaction is encrypted and protected.",
      support: "24/7 Support",
      support_sub: "Our team is always available to help you.",
      category: "Category",
      platform: "Platform",
      type: "Type",
      back: "Back",
    },
    cart: {
      title: "Shopping Cart",
      summary: "Order Summary",
    },
    checkout: {
      title: "Checkout",
      processing: "Processing payment…",
      success: "Payment successful!",
      success_sub: "Your digital products are ready in your dashboard.",
      see_orders: "See my orders",
      verifying: "Verifying payment…",
      failed: "Payment was not completed",
      try_again: "Try again",
    },
    admin: {
      dashboard: "Dashboard",
      welcome: "Welcome back, Admin! Here's your store overview.",
      products: "Products",
      orders: "Orders",
      users: "Users",
      categories: "Categories",
      coupons: "Coupons",
      reviews: "Reviews",
      gift_cards: "Gift Cards",
      subscriptions: "Subscriptions",
      premium_accounts: "Premium Accounts",
      banners: "Banners",
      notifications: "Notifications",
      transactions: "Transactions",
      reports: "Reports",
      settings: "Settings",
      integrations: "Integrations",
      permissions: "Permissions",
      total_sales: "Total Sales",
      avg_ticket: "Avg. Ticket",
      conversion: "Conversion Rate",
      sales_30: "Sales (Last 30 days)",
      by_category: "Sales by Category",
      top_products: "Top Selling Products",
      orders_status: "Orders by Status",
      recent_orders: "Recent Orders",
      activity: "Recent Activity",
      quick_actions: "Quick Actions",
      add_product: "Add Product",
      add_banner: "Add Banner",
      manage_coupons: "Manage Coupons",
      view_reports: "View Reports",
      view_orders: "View Orders",
      view_users: "View Users",
    },
  },
  pt: {
    common: {
      shop_now: "Comprar Agora",
      explore_deals: "Ver Ofertas",
      see_all: "Ver todos",
      add_to_cart: "Adicionar ao carrinho",
      buy_now: "Comprar agora",
      out_of_stock: "Esgotado",
      in_stock: "Em estoque",
      search_placeholder: "Buscar jogos, gift cards…",
      cart: "Carrinho",
      wishlist: "Favoritos",
      account: "Conta",
      login: "Entrar",
      register: "Cadastrar",
      logout: "Sair",
      dashboard: "Painel",
      orders: "Pedidos",
      settings: "Configurações",
      admin: "Admin",
      currency_symbol: "R$",
      total: "Total",
      subtotal: "Subtotal",
      discount: "Desconto",
      service_fee: "Taxa de serviço",
      checkout: "Finalizar Compra",
      continue_shopping: "Continuar comprando",
      apply: "Aplicar",
      promo_code: "Código promocional",
      qty: "Qtd",
      remove: "Remover",
      empty_cart: "Seu carrinho está vazio",
      empty_wishlist: "Sua lista de favoritos está vazia",
      explore_now: "Explorar agora",
      free: "Grátis",
      added: "Adicionado ao carrinho",
      removed: "Removido",
      please_login: "Faça login para continuar",
      welcome_back: "Bem-vindo de volta",
      create_account: "Crie sua conta",
      no_account: "Não tem conta?",
      have_account: "Já tem conta?",
      email: "Email",
      password: "Senha",
      name: "Nome",
      sign_in: "Entrar",
      sign_up: "Cadastrar",
    },
    nav: {
      games: "Jogos",
      gift_cards: "Gift Cards",
      subscriptions: "Assinaturas",
      deals: "Promoções",
      new_releases: "Novidades",
      support: "Suporte",
      home: "Início",
    },
    hero: {
      title_a: "LEVEL UP",
      title_b: "YOUR DIGITAL",
      title_c: "WORLD",
      subtitle: "Jogos, gift cards e assinaturas com entrega instantânea.",
      badge: "Marketplace Gamer Premium",
    },
    home: {
      featured_games: "Jogos em Destaque",
      trending: "Em Alta",
      flash_deals: "Ofertas Relâmpago",
      new_releases: "Novos Lançamentos",
      gift_cards: "Gift Cards",
      subscriptions: "Assinaturas Gamer",
      top_sellers: "Mais Vendidos",
      recently_added: "Adicionados Recentemente",
      popular_categories: "Categorias Populares",
      reviews: "O que dizem os gamers",
      newsletter_title: "Não perca nenhuma oferta",
      newsletter_sub: "Assine e receba ofertas exclusivas e acesso antecipado.",
      newsletter_cta: "Assinar",
      strip: {
        instant: { t: "Entrega Instantânea", s: "Receba em minutos" },
        secure: { t: "Pagamento Seguro", s: "Ambiente 100% seguro" },
        prices: { t: "Melhores Preços", s: "Ofertas imperdíveis" },
        support: { t: "Suporte 24/7", s: "Atendimento dedicado" },
      },
    },
    product: {
      similar: "Produtos similares",
      description: "Descrição",
      requirements: "Requisitos",
      reviews: "Avaliações",
      delivery: "Entrega instantânea",
      delivery_sub: "Receba o código em minutos após a confirmação do pagamento.",
      secure: "Pagamento seguro",
      secure_sub: "Sua transação é criptografada e protegida.",
      support: "Suporte 24/7",
      support_sub: "Nossa equipe está sempre pronta para te ajudar.",
      category: "Categoria",
      platform: "Plataforma",
      type: "Tipo",
      back: "Voltar",
    },
    cart: {
      title: "Carrinho de Compras",
      summary: "Resumo do Pedido",
    },
    checkout: {
      title: "Finalizar Compra",
      processing: "Processando pagamento…",
      success: "Pagamento confirmado!",
      success_sub: "Seus produtos digitais estão prontos no seu painel.",
      see_orders: "Ver meus pedidos",
      verifying: "Verificando pagamento…",
      failed: "Pagamento não foi concluído",
      try_again: "Tentar novamente",
    },
    admin: {
      dashboard: "Painel",
      welcome: "Bem-vindo de volta, Admin! Aqui está o resumo da sua loja.",
      products: "Produtos",
      orders: "Pedidos",
      users: "Usuários",
      categories: "Categorias",
      coupons: "Cupons",
      reviews: "Avaliações",
      gift_cards: "Gift Cards",
      subscriptions: "Assinaturas",
      premium_accounts: "Contas Premium",
      banners: "Banners",
      notifications: "Notificações",
      transactions: "Transações",
      reports: "Relatórios",
      settings: "Configurações",
      integrations: "Integrações",
      permissions: "Permissões",
      total_sales: "Vendas Totais",
      avg_ticket: "Ticket Médio",
      conversion: "Taxa de Conversão",
      sales_30: "Vendas (Últimos 30 dias)",
      by_category: "Vendas por Categoria",
      top_products: "Produtos Mais Vendidos",
      orders_status: "Pedidos por Status",
      recent_orders: "Pedidos Recentes",
      activity: "Atividade Recente",
      quick_actions: "Ações Rápidas",
      add_product: "Adicionar Produto",
      add_banner: "Adicionar Banner",
      manage_coupons: "Gerenciar Cupons",
      view_reports: "Ver Relatórios",
      view_orders: "Ver Pedidos",
      view_users: "Ver Usuários",
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gf_lang") || "pt");
  useEffect(() => {
    localStorage.setItem("gf_lang", lang);
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let v = TRANSLATIONS[lang];
    for (const p of parts) {
      if (v && typeof v === "object") v = v[p];
      else return path;
    }
    return v ?? path;
  };

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
